/**
 * Pricing-page fee display: keep significant digits, drop trailing
 * fractional zeros and a dangling decimal point.
 *
 * Shared formatters stay padded (GiftBalanceLine, Requests, Usage, …);
 * only `/pricing` runs amounts through this.
 *
 * ¥0.350000 → ¥0.35, ¥14.00 → ¥14, ¥0.000001 stays. Non-¥ strings
 * (em dash, "Not billed") pass through.
 */
export function trimCnyTrailingZeros(formatted: string): string {
  return formatted.replace(/¥[\d,]+\.\d+/g, (amount) =>
    amount.replace(/0+$/, '').replace(/\.$/, ''),
  );
}
